/**
 * Detecta el contexto de la app según el hostname:
 * - localhost / rentahab.com → Master Platform
 * - stef.localhost / stef.rentahab.com → tenant "stef"
 */

const DEV_CENTRAL_HOSTS = ['localhost', '127.0.0.1'];
const PROD_CENTRAL_HOSTS = ['rentahab.com', 'www.rentahab.com'];

function getApiPort() {
  if (process.env.REACT_APP_API_PORT) {
    return process.env.REACT_APP_API_PORT;
  }

  const base = process.env.REACT_APP_URL_BASE_API;
  if (base) {
    try {
      const url = new URL(base);
      if (url.port) return url.port;
    } catch {
      // ignore
    }
  }

  return '8000';
}

function buildApiOrigin(hostname, protocol, port) {
  const defaultPort = protocol === 'https:' ? '443' : '80';
  const resolvedPort = port || defaultPort;

  if (resolvedPort === defaultPort || resolvedPort === '80' || resolvedPort === '443') {
    return `${protocol}//${hostname}`;
  }

  return `${protocol}//${hostname}:${resolvedPort}`;
}

export function getAppContext() {
  if (typeof window === 'undefined') {
    return {
      mode: 'tenant',
      tenantSlug: process.env.REACT_APP_TENANT_SLUG || 'demo',
      apiBaseUrl: process.env.REACT_APP_URL_BASE_API || 'http://localhost:8000/api',
      tenantDomainSuffix: '.localhost',
    };
  }

  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const apiPort = getApiPort();
  const apiOrigin = buildApiOrigin(hostname, protocol, apiPort);

  const isCentral =
    DEV_CENTRAL_HOSTS.includes(hostname) || PROD_CENTRAL_HOSTS.includes(hostname);

  if (isCentral) {
    return {
      mode: 'platform',
      tenantSlug: null,
      apiBaseUrl: `${apiOrigin}/api/platform`,
      tenantDomainSuffix: hostname === 'localhost' || hostname === '127.0.0.1' ? '.localhost' : '.rentahab.com',
    };
  }

  const slug = hostname.split('.')[0];

  return {
    mode: 'tenant',
    tenantSlug: slug,
    apiBaseUrl: `${apiOrigin}/api`,
    tenantDomainSuffix: hostname.includes('.localhost') ? '.localhost' : '.rentahab.com',
  };
}

export function isPlatformMode() {
  return getAppContext().mode === 'platform';
}

export function isTenantMode() {
  return getAppContext().mode === 'tenant';
}

export function buildTenantLoginUrl(slug) {
  if (!slug) return '';

  if (typeof window === 'undefined') {
    return `http://${slug}.localhost:3001/login`;
  }

  const { tenantDomainSuffix } = getAppContext();
  const protocol = window.location.protocol;
  const port = window.location.port;
  const portSuffix = port && !['80', '443'].includes(port) ? `:${port}` : '';

  return `${protocol}//${slug}${tenantDomainSuffix}${portSuffix}/login`;
}
